var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa-fw self-center",class:[_vm.iconStyleAbbreviation, 'fa-' + _vm.icon, this.textSizeClass]})
}
var staticRenderFns = []

export { render, staticRenderFns }